<template>
  <div
    class="why-us-section shade-section"
    style="padding: 4rem 0"
  >
    <div class="container">
      <div class="row">
        <div class="col-md-12 mb-4">
          <h3 class="text-center">
            {{ $t(title) }}
          </h3>
          <p class="text-center product-line-subtitle">
            {{ $t(description) }}
          </p>
        </div>
        <div class="col-md-12">
          <div class="row">
            <template v-if="products.length > 0">
              <div
                class="col-12 col-md-6 col-lg-3 pl-lg-1"
                :key="key"
                v-for="(product, key) in products"
              >
                <home-product-card-item :product="product" />
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeProductCardItem from '@/views/includes/home/includes/HomeProductCardItem'

export default {
  name: 'HomeProductSection',
  components: { HomeProductCardItem },
  data () {
    return {
      title: 'string.productLineTitle',
      description: 'string.productLineSubtitle',
      products: [
        {
          title: 'label.payDayLoan',
          description: 'product.subtitle.payday',
          link: 'payday_loan',
          icon: 'img/icons/payday_loan.svg',
          icon_width: 45,
          mb: 35,
          is_icon: false,
          start_from: process.env.VUE_APP_PAYDAY_MIN_DISPLAY,
          up_to: process.env.VUE_APP_PAYDAY_MAX_DISPLAY,
          over: 'product.over.payday',
          use_for: 'product.useFor.payday'
        },
        {
          title: 'label.personalLoan',
          description: 'product.subtitle.personal',
          link: 'personal_loan',
          icon: 'img/icons/personal_loan.svg',
          icon_width: 45,
          mb: 35,
          is_icon: false,
          start_from: process.env.VUE_APP_PERSONAL_LOAN_MIN_DISPLAY,
          up_to: process.env.VUE_APP_PERSONAL_LOAN_MAX_DISPLAY,
          over: 'product.over.personal',
          use_for: 'product.useFor.personal'
        },
        {
          title: 'label.purchasing',
          description: 'product.subtitle.purchasing',
          link: 'purchasing',
          icon: 'img/icons/purchasing_loan.svg',
          icon_width: 50,
          mb: 30,
          is_icon: false,
          start_from: process.env.VUE_APP_PURCHASE_MIN_DISPLAY,
          up_to: process.env.VUE_APP_PURCHASE_MAX_DISPLAY,
          over: 'product.over.pawn',
          use_for: 'product.useFor.purchasing'
        },
        {
          title: 'label.pawn',
          description: 'product.subtitle.pawn',
          link: 'pawn',
          icon: 'img/icons/pawn_loan.svg',
          icon_width: 50,
          mb: 30,
          is_icon: false,
          start_from: process.env.VUE_APP_PAWN_MIN_DISPLAY,
          up_to: process.env.VUE_APP_PAWN_MAX_DISPLAY,
          over: 'product.over.pawn',
          use_for: 'product.useFor.pawn'
        }
      ]
    }
  }
}
</script>

<style scoped>
.page-section {
  background-color: var(--shade) !important;
}

.product-line-subtitle {
  width: 50%;
  margin: 0 auto;
}
@media screen and (max-width: 1200px) {
  .product-line-subtitle {
    width: 70%;
    margin: 0 auto;
  }
}

@media screen and (max-width: 991.98px) {
  .product-line-subtitle {
    width: 90%;
    margin: 0 auto;
  }
}

@media screen and (max-width: 767px){
  .product-line-subtitle {
    width: 100%;
    margin: 0;
  }
}
</style>
